const getters =  {
    getDetailsId:(state, getters) => {
        console.log(state.detailsID)
        return state.detailsID
    } 
}
export default getters